import { useState } from "react"
import styled from "@emotion/styled"
import { Button, IconButton, MenuItem, Popover } from "@mui/material"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { COLOR_MAP } from "../../../../constants/ColorNames";

type PlaceholderProps = {
    onDropDownClick: (id: string) => void
}

const StyledButton = styled(Button)`
    text-transform: capitalize;
    padding: 0.4rem;
    font-size: 1.2rem;
    line-height: 1.6rem;
    padding: 0.8rem 1.2rem;
`

const Icon = styled(IconButton)`
    padding-left: 0.5rem;
    color: ${COLOR_MAP.GREY_2};
`
const Placeholder = (props: PlaceholderProps) => {
    const { onDropDownClick } = props
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (name?: string) => {
        if (name) {
            onDropDownClick(name)
        }

        setAnchorEl(null);
    };


    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const placeholders = ['@candidate_full_name', '@candidate_current_location', '@candidate_key_skills','@candidate_education', '@company_name']

    return (<>
        <StyledButton
            disableRipple
            aria-describedby={id}
            onClick={handleClick}
            variant="outlined">
            @Placeholders
            <Icon disableRipple >
                {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Icon>
        </StyledButton>
        {open && <Popover

            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={() => handleClose()}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
            }}
            sx={{
                '.MuiPaper-root': {
                    maxWidth: '24.7rem'
                }
            }}
        >
      {placeholders.map(placeholder => {
        return (
          <MenuItem
          onClick={() => handleClose(`${placeholder}:`)}
          sx={{
              padding: '0.8rem !important'
          }}
      >
          {placeholder}
      </MenuItem>
        )
      })}
        </Popover >
        }
    </>)

}

export default Placeholder